<template>
    <div id="resourceForm" class="con-exemple-prompt">
        <!-- Titre -->
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Libellé* :</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                    v-if="type != 'show'"
                    v-model="resource.title"
                    name="title"
                    size="large"
                    class="w-full"
                />
                <b v-else>{{ resource.title }}</b>
            </div>
        </div>

        <!-- Choix du type -->
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Type* :</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <template v-if="type != 'show'">
                    <div
                        ref="tooltip"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Cette donnée permet de catégoriser vos question. Vous pouvez sélectionner une valeur existante ou en ajouter une nouvelle.">

                        <TypeForm
                            v-model="resource.type"
                            :availableTypes="types.data"
                        ></TypeForm>
                    </div>
                </template>
                <span v-else>{{ resource.type }}</span>
            </div>
        </div>

        <!-- Signification des réponses -->
        <div class="mb-10">
            <vs-collapse accordion class="mb-6 mt-10">
                <vs-collapse-item>
                    <div slot="header">
                        <h5>Signification des réponses : </h5>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col sm:w-2/5 w-full flex items-center justify-start">
                            <b>0 - Pas du tout d'accord : </b>
                        </div>
                        <div class="input-level vx-col sm:w-3/5 w-full">
                            <span v-if="type == 'show'">{{ resource.levels.level_0 }}</span>
                            <vs-input 
                                v-else 
                                v-model="resource.levels.level_0" 
                                name="levels_level_0" 
                                class="w-full"
                                placeholder="0 : " 
                                type="text" 
                            />
                        </div>
                    </div>
                    <div class="vx-row mt-3">
                        <div class="vx-col sm:w-2/5 w-full flex items-center justify-start">
                            <b>1 - Plutôt pas d'accord : </b>
                        </div>
                        <div class="input-level vx-col sm:w-3/5 w-full">
                            <span v-if="type == 'show'">{{ resource.levels.level_1 }}</span>
                            <vs-input 
                                v-else 
                                v-model="resource.levels.level_1" 
                                name="levels_level_1" 
                                class="w-full"
                                placeholder="1 : " 
                                type="text"
                            />
                        </div>
                    </div>
                    <div class="vx-row mt-3">
                        <div class="vx-col sm:w-2/5 w-full flex items-center justify-start">
                            <b>2 - Plutôt d'accord : </b>
                        </div>
                        <div class="input-level vx-col sm:w-3/5 w-full">
                            <span v-if="type == 'show'">{{ resource.levels.level_2 }}</span>
                            <vs-input 
                                v-else 
                                v-model="resource.levels.level_2" 
                                name="levels_level_2" 
                                class="w-full"
                                placeholder="2 : " 
                                type="text" 
                            />
                        </div>
                    </div>
                    <div class="vx-row mt-3">
                        <div class="vx-col sm:w-2/5 w-full flex items-center justify-start">
                            <b>3 - Tout à fait d'accord : </b>
                        </div>
                        <div class="input-level vx-col sm:w-3/5 w-full">
                            <span v-if="type == 'show'">{{ resource.levels.level_3 }}</span>
                            <vs-input 
                                v-else 
                                v-model="resource.levels.level_3" 
                                name="levels_level_3" 
                                class="w-full"
                                placeholder=" 3 : " 
                                type="text" 
                            />
                        </div>
                    </div>
                </vs-collapse-item>
            </vs-collapse>

        </div>

        <!-- Image -->
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full pl-12">
                <span>Image (.jpg, .png, .webp) :</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full pl-8 pr-12">
                <avatar-cropper
                    v-if="type != 'show'"
                    :id="'cropper'"
                    :trigger="'#edited-pick-photo'"
                    :labels="{ submit: 'Soumettre', cancel: 'Annuler' }"
                    :upload-handler="submitPhoto"
                    :cropper-options="{'aspectRatio': '16:9', 'autoCropArea': 1, 'viewMode': 1, 'movable': false, 'zoomable': false}"
                />
                <div :id="'edited-pick-photo'" style="text-align:center; font-size: 20px; background-color: grey; color: white; width: 470px; height: 36px;">
                    <small>Cliquez pour Modifier/Ajouter la photo avec un fichier</small>
                </div>
                <!--<vs-input
                    type="file"
                    name="file"
                    class="w-full"
                    @change="changeFileHandle"
                />-->
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full pl-12">
                <span>Lien vers une image du savoir-faire (lien public, libre de droits): </span>
            </div>
            <div class="vx-col sm:w-4/5 w-full pl-8 pr-12">
                <vs-input
                    v-if="type != 'show'"
                    v-model="resource.photo"
                    name="resourcePhoto"
                    class="w-full"
                />
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full pl-12">
                <span>Aperçu :</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full pl-8 pr-12">
                <img
                    v-if="!isVideoFile(resource.photo)"
                    id="edited-pick-photo"
                    :src="resource.photo"
                    width="120px"
                />
                <iframe
                    v-else
                    width="100%"
                    height="315"
                    :src="resource.photo"
                    title="Video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen>
                </iframe>
            </div>
        </div>

        <!-- Audio -->
        <div v-if="isASuperAdmin()" class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full pl-12">
                <span>Description audio (*.mp3)</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full pl-8 pr-12">
                <div v-if="resource.audio_description" class="w-full flex items-center mb-2">
                    <audio controls>
                        <source :src="resource.audio_description" type="audio/mp3"></source>
                        Your browser does not support the audio element.
                    </audio>
                    <div v-if="type != 'show'" class="ml-5">
                        <vs-button color="danger" @click="() => resource.audio_description = null">
                            Supprimer l'audio
                        </vs-button>
                    </div>
                </div>
                
                <vs-input
                    v-if="type != 'show'"
                    name="audio_description"
                    type="file"
                    accept="audio/mp3, .mp3"
                    class="w-full"
                    @change="setAudioDescription"
                    :danger="this.fileError.message"
                    :danger-text="this.fileError.message"
                />
                
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import TypeForm from "@components/form/TypeForm";
import AvatarCropper from 'vue-avatar-cropper'

export default {
    name: 'ServiceForm',
    components: {
        Multiselect,
        TypeForm,
        AvatarCropper
    },
    props: {
        value: {
            required: false,
            type: Object
        },
        type: {
            required: true,
            type: String
        },
        isCreation: {
            required: false,
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            resource: {},
            types: {
                data: [],
                loading: false
            },
            fileError: {
                message: null,
            },
        }
    },
    watch: {
        value (newValue, oldValue) {
            if (newValue === oldValue) return
            this.initResource()
        },
        'resource': {
            handler () {
                this.value.title                  = this.resource.title
                this.value.type                   = this.resource.type
                this.value.description            = this.resource.description
                this.value.levels                 = {...this.resource.levels}
                this.value.audio_description      = this.resource.audio_description
                this.value.audio_description_blob = this.resource.audio_description_blob;
                this.value.photo                  = this.resource.photo
                this.value.photo_blob             = this.resource.photo_blob
                this.$emit('input', this.value)
            }, deep: true
        },
        hasError (value) {
            this.$emit('error', value)
        }
    },
    computed: {

        hasError() {
            let error = !this.resource.title || !this.resource.type
            return error;
        },

    },
    methods: {
        async loadTypes() {
            this.types.loading = true

            return window.axios({
                method: 'get',
                url: '/api/referentiel/questions/types',
            })
            .then(response => {
                this.types.data = response.data;
                this.types.loading = false;
            })
            .catch((err) => {
                console.log(err)
                this.notifyError(err, `Une erreur est survenue`)
            })
        },

        setAudioDescription(ev) {
            this.fileError.message = null
            this.resource.audio_description_blob = null

            if (ev.target.files.length !== 0) {
                Array.from(ev.target.files).forEach(file => {
                    if (file.size >= this.maxFileSize*1024*1024) {
                        this.fileError.message = 'La taille du fichier de '+this.getReadableFileSizeString(file.size)+' est supérieure à la valeur autorisée de ' + this.maxFileSize+' Mo'
                    } else {
                        this.$set(this.resource, 'audio_description_blob', file)
                    }
                })
            }
        },
        submitPhoto(ev) {
            ev.getCroppedCanvas({ width: 512, height: 512 }).toBlob(blob => {
                    this.resource.photo_blob = blob
                    this.resource.photo = URL.createObjectURL(blob)
                },
                'image/jpeg',
                0.9
            )
        },
        
        initResource() {
            this.resource = {
                type: this.value.type,
                title: this.value.title,
                description: this.value.description,
                levels: {...this.value.levels},
                photo: this.value.photo,
                photo_blob: null,
                audio_description: this.value.audio_description,
                audio_description_blob: null
            }
        },

    },
    created() {
        this.initResource();

        this.$vs.loading();
        Promise.all([
            this.loadTypes(),
        ]).then(() => {
            this.$vs.loading.close();
        });
    }
}
</script>
